//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const styles = makeStyles((theme) => ({
  root: {
    marginBottom: 20,
    display: 'flex',
    justifyContent: 'end'
  },
  tableDownInResponsive: {
    marginBottom: 150,
  },
  createBtn: {
    marginRight: 5
  },
  link: {
    color: "blue",
    textDecoration: "underline",
    cursor: "pointer",
  },
  // Create
  dateInput: {
    width: "100%",
  },
  submitBtn: {
    color: "#fff",
    backgroundColor: "#305698 !important",
    fontSize: 15,
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    textTransform: "capitalize",
    width: 100,
    height: 35,
    "&:hover": {
      backgroundColor: "#305698 !important",
    },
    cursor: 'pointer'
  },
  // View
  label: {
    verticalAlign: "-webkit-baseline-middle",
  },
  editInput: {
    width: "80%",
  },
  cancelBtn: {
    color: "#305698",
    backgroundColor: "#fff !important",
    fontSize: 15,
    border: "1px solid #2F7CBD",
    borderRadius: 10,
    textTransform: "capitalize",
    width: 100,
    "&:hover": {
      backgroundColor: "#fff !important",
    },
  },
  // Dialog
  dialogParentDiv: {
    padding: 25,
  },
  parentText: {
    fontSize: 25,
  },
  gridContainer: {
    width: "100%",
    margin: "0 auto",
  },
  // griditem :{
  //   padding: "-40px !important", // Optional padding for grid items
  // },
  formControlLabel: {
    marginBottom: "10px", // Space between checkboxes
    width:"100%"
  },
  checkbox: {
    padding: "5px",
  },
  popupBtnDiv: {
    height: 60,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
},
closeIcon: {
    fontSize: 16,
    position: 'absolute',
    top: 5,
    right: 5,
    cursor: 'pointer'
},
}));
